export default {"src":"/_next/static/media/medias.404b48c8.svg","height":29,"width":302,"blurWidth":0,"blurHeight":0};